import React from 'react'
import {Progress, Typography} from 'antd';
import IClaim from "../../../../../model/interface/company/workload/IClaim";
import {MomentBuilder} from "../../../../../utils/MomentBuilder";
import IObligation from "../../../../../model/interface/company/IObligation";
import {humanShiftHoursInDays} from "../../../file-manager/utils/TimeDuration";
import LocaleText from "../../../settings/dictionary/LocaleText";
import {IAppState} from "../../../../../redux/store";
import selectors from "../../../../../redux/selectors";
import {connect} from "react-redux";
import {Info} from "./Info";

const {Text} = Typography;

interface IProps {
    claim: IClaim,
    obligation: IObligation
    getText: (code: string, fallBack?: string) => string
    showValidity?: boolean
}

interface IState {

}

export class Status extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props)
        this.state = {} as IState
    }


    getDays(obligation: IObligation, total: number) {
        return obligation.dayWorkHours && <> ({humanShiftHoursInDays(total, obligation.dayWorkHours, this.props.getText)})</>;
    }

    render() {
        const {claim, showValidity, obligation} = this.props
        const planned = claim ? claim.amountPlanned + claim.amountApproved + claim.amountPending : 0
        return <>
            {claim ?
                <>
                    {showValidity &&
                        <Text strong>{
                            MomentBuilder.build(claim.validFrom).format('LL')} -
                            {MomentBuilder.build(claim.validUntil).format('LL')}
                        </Text>}
                    <Progress showInfo={false} percent={100 * (claim.amountSpent + planned) / claim.amountTotal}
                              success={{percent: (100 * claim.amountSpent / claim.amountTotal)}} size="small"/>

                    <LocaleText code={'company.claim.status.total'} fallback={'Nárok'}/>:{' '}<Text strong>{claim.amountTotal}h</Text> {this.getDays(obligation, claim.amountTotal)},
                    <LocaleText code={'company.claim.status.spent'} fallback={'Čerpáno'}/>:{' '}<Text strong>{claim.amountSpent}h</Text> {this.getDays(obligation, claim.amountSpent)},
                    <LocaleText code={'company.claim.status.planned'} fallback={'Plánováno'}/>:{' '}<Text strong>{planned}h</Text> {this.getDays(obligation, planned)},
                    <LocaleText code={'company.claim.status.left'} fallback={'Zůstatek'}/>:{' '}<Text strong>{claim.amountFree}h</Text> {this.getDays(obligation, claim.amountFree)}
                </>
                : (
                    <span className={"text-muted"}><LocaleText code={'general.no-records'}/></span>
                )}
        </>
    }
}

const mapStateToProps = (state: IAppState) => {
    return {
        getText: (code: string, fallback?: string) => selectors.dictionary.getMessage(state, code, fallback)
    }
}

export default connect(mapStateToProps)(Status)